/**
 * AdjustAddonsCtrl controller
 * Add/Edit Payment statement comment
 */
import { CONTENT_TYPES_SETS } from '../../../app/core/constants'

/**
 * AdjustAddonsCtrl controller
 *
 * @class AdjustAddonsCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:AdjustAddonsCtrl
 */
/* @ngInject */
export default function AdjustAddonsCtrl ($uibModalInstance, $http, activeFrom, activeUntil, addons) {
  var vm = this

  vm.activeFrom = activeFrom
  vm.addons = addons
  vm.content_types_sets = CONTENT_TYPES_SETS
  vm.unsetDisable()

  vm.adjustAddonsLength = !!vm.addons.find(a => a.$adjustEnabled)

  vm.activeUntil = function (addon = null) {
    if (!addon) {
      return activeUntil
    }
    if (vm.adjustAddonsLength && addon.$adjustEnabled) {
      return activeUntil
    }
    return angular.copy(activeFrom).setDate(activeFrom.getDate() + (addon.timeUnit === 'DAY' ? addon.period : addon.period * 30))
  }

  vm.showLength = function (addon) {
    if (vm.adjustAddonsLength && addon.$adjustEnabled) {
      if (!isNaN(vm.activeUntil(addon))) {
        const timeDiff = activeUntil.getTime() - activeFrom.getTime()
        const currentLength = Math.ceil(timeDiff / (1000 * 3600 * 24))
        const addonLength = addon.timeUnit[0] === 'D' ? addon.period : addon.period * 30
        addon.extraLength = currentLength - addonLength
        return addon.period + addon.timeUnit[0] + (addon.extraLength !== 0 ? (' (' + (addon.extraLength > 0 ? '+' + addon.extraLength : addon.extraLength) + 'D)') : '')
      } else {
        return addon.period + addon.timeUnit[0] + ' ()'
      }
    }
    return addon.period + addon.timeUnit[0]
  }

  vm.disableSubmit = function () {
    return !vm.addons.every(addon => {
      if (!addon.$adjustEnabled) {
        return true
      }
      return addon.$adjustEnabled && !isNaN(vm.activeUntil(addon))
    })
  }

  vm.changeAdjust = function () {
    vm.adjustAllAddons = vm.addons.reduce((acc, a) => {
      return acc && a.$adjustEnabled
    }, true)
  }

  vm.changeAdjustAll = function () {
    vm.addons.forEach((a) => {
      a.$adjustEnabled = vm.adjustAllAddons
    })
  }

  /**
   * Create or edit comment, and close modal window afterwards
   *
   * @memberof mwApp/subscribers.controller:AdjustAddonsCtrl
   */
  vm.submit = function () {
    if (!vm.adjustAddonsLength) {
      vm.addons.forEach((a) => {
        a.$adjustEnabled = false
      })
    }
    $uibModalInstance.close(vm.addons)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/subscribers.controller:AdjustAddonsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
